var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-reservation-summary" },
    [
      _c("div", {
        staticClass:
          "c-reservation-summary__divider without-margin-top desktop-only",
      }),
      _vm._v(" "),
      _c("div", { staticClass: "c-reservation-summary__item" }, [
        _c("div", { staticClass: "c-reservation-summary__label" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("BranchReservation.Summary.Quantity.title"))),
          ]),
          _vm._v(" "),
          _c("small", { staticClass: "cxs-is-visible" }, [
            _vm._v(
              _vm._s(_vm.$t("BranchReservation.Summary.Quantity.tooltip"))
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-reservation-summary__quantity" },
          [
            _c(
              "r-spinner",
              {
                ref: "rSpinner",
                staticClass: "c-form__quantity",
                class: {
                  "is-disabled": _vm.isQuantityDisabled,
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "c-btn is-decrement",
                    attrs: { type: "button", decrement: "" },
                  },
                  [_vm._v("\n                    –\n                ")]
                ),
                _vm._v(" "),
                _c("input", {
                  staticClass: "c-form__input",
                  attrs: {
                    name: "quantity",
                    type: "text",
                    autocomplete: "off",
                    min: _vm.min,
                    max: _vm.max,
                    readonly: _vm.isQuantityDisabled,
                  },
                  domProps: { value: _vm.quantity },
                  on: { change: _vm.onQuantityChange },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "c-btn is-increment",
                    attrs: { type: "button", increment: "" },
                  },
                  [_vm._v("\n                    +\n                ")]
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.selectedBranch
              ? _c("i", {
                  staticClass: "ico ico-circle-info js-tippy cxs-is-hidden",
                  attrs: {
                    "data-tippy-content": _vm.$t(
                      "BranchReservation.Summary.Quantity.tooltip"
                    ),
                    "data-z-index": "1050",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-reservation-summary__divider" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "c-reservation-summary__item c-reservation-summary__item--payment",
        },
        [
          _c("div", { staticClass: "c-reservation-summary__label" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("BranchReservation.Summary.Payment.title")) +
                "\n            "
            ),
            _c("small", { staticClass: "cxs-is-visible" }, [
              _vm._v(
                _vm._s(_vm.$t("BranchReservation.Summary.Payment.tooltip"))
              ),
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "ico ico-circle-info js-tippy cxs-is-hidden",
              attrs: {
                "data-tippy-content": _vm.$t(
                  "BranchReservation.Summary.Payment.tooltip"
                ),
                "data-z-index": "1050",
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-reservation-summary__value" }, [
            _c("strong", { staticClass: "h-is-green" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("BranchReservation.Summary.Payment.free")) +
                  "\n            "
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "c-reservation-summary__divider" }),
      _vm._v(" "),
      _c("ReservationVoucher"),
      _vm._v(" "),
      _c("div", { staticClass: "c-reservation-summary__divider" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "c-reservation-summary__item c-reservation-summary__item--price",
        },
        [
          _c("div", { staticClass: "c-reservation-summary__label" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("BranchReservation.Summary.Price.total")) +
                " " +
                _vm._s(_vm.$t("withVat")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-reservation-summary__value is-bigger" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.totals ? _vm.formatPrice(_vm.totals.price_vat) : "-"
                ) +
                "\n        "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "c-reservation-summary__item c-reservation-summary__item--price",
        },
        [
          _c(
            "div",
            { staticClass: "c-reservation-summary__label is-gray is-smaller" },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("BranchReservation.Summary.Price.total")) +
                  " " +
                  _vm._s(_vm.$t("withoutVat")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "c-reservation-summary__value is-gray" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.totals ? _vm.formatPrice(_vm.totals.price) : "-") +
                "\n        "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.totals
        ? _vm._l(_vm.totals.taxes, function (tax) {
            return _c(
              "div",
              {
                key: tax.value,
                staticClass:
                  "c-reservation-summary__item c-reservation-summary__item--price",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "c-reservation-summary__label is-gray is-smaller",
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("BranchReservation.Summary.Price.vat")) +
                        " " +
                        _vm._s(tax.value) +
                        "%\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "c-reservation-summary__value is-gray" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.formatPrice(tax.price)) +
                        "\n            "
                    ),
                  ]
                ),
              ]
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.totals && _vm.totals.discount
        ? _c(
            "div",
            {
              staticClass:
                "c-reservation-summary__item c-reservation-summary__item--price",
            },
            [
              _c(
                "div",
                {
                  staticClass: "c-reservation-summary__label is-red is-smaller",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("BranchReservation.Summary.Price.discount")
                      ) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-reservation-summary__value is-red" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.formatPrice(_vm.totals.discount)) +
                      "\n        "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }